import { Subject } from "rxjs";

import { InjectorInterface } from "./InjectorInterface";

class MutationObserverInjector implements InjectorInterface {
    private mo: MutationObserver;
    public targets$ = new Subject<HTMLElement>();
    private foundElements = new WeakSet();
    constructor(
        private readonly MutationObserverCls: typeof MutationObserver,
        private readonly options: {
            mutationTarget: HTMLElement;
            targetSelector: string;
        }
    ) {
        this.mo = new this.MutationObserverCls(this.mutationCallback);
    }
    start(): void {
        this.checkElementOnPage();
        this.mo.observe(this.options.mutationTarget, {
            attributes: true,
            childList: true,
            subtree: true,
        });
    }
    stop() {
        this.mo.disconnect();
    }
    checkElementOnPage(): void {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        const targets = document.querySelectorAll<HTMLElement>(
            this.options.targetSelector
        );
        if (!targets) return;
        for (const target of targets) {
            if (this.foundElements.has(target)) continue;
            this.foundElements.add(target);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            this.targets$.next(target);
        }
    }
    mutationCallback: MutationCallback = () => {
        this.checkElementOnPage();
    };
}

export default MutationObserverInjector;
